import * as Native from './native'

export default function Tooltip(props){
    return <Native.Tooltip {...props} />
}